import React, { useState, useEffect } from "react";
import SmallBanner from "../../assets/components/smallBanner";
import Banner from "../../assets/components/banner";
import appApi from "../../assets/utils/AppApi";
import BannerSlider from "../../assets/containers/bannerSlider";
import Skeleton from "@mui/material/Skeleton";
import Classes from "./Styles/Style.module.css";

export const ArchiveBanner = () => (
  <div className="col-12 mx-0 px-0 px-md-2">
    <Banner
      src="https://app.rahebehesht.com/wp-content/uploads/2024/01/archive-banner.jpg"
      href="/archive"
      title="پرونده ها"
      showText={false}
      glow={false}
      linkNewTab={false}
    />
  </div>
);

function BottomBanners({ includeArchive = true }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const getBottomBanners = async () => {
    try {
      await appApi
        .get(`/banner/getbyposition/Bottom?page=${1}&limit=999`)
        .then(({ data }) => {
          // Push fixed data at the start of the banners
          const startDataCopy = []

          const dataCopy = [...startDataCopy, ...data.docs].sort((a, b) => b.index - a.index);
          setLoading(false);
          setData(dataCopy);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getBottomBanners();
  }, []);

  const skeletonArray = new Array(5).fill(null);

  return (
    <div className={`w-100 row mx-0 px-0 justify-content-between ${Classes.fixedBannersList}`}>
      {loading
        ? skeletonArray.map((_, index) => {
            return (
              <Skeleton
                variant="rounded"
                width={"95%"}
                sx={{
                  marginInline: "auto",
                  marginBlock: "1rem",
                  borderRadius: "1rem",
                }}
                height={120}
                key={index}
                animation="wave"
              />
            );
          })
        : data.map((banner, index) => {
            if (banner.type === "Video") {
              return (
                <BannerSlider
                  banners={[{ ...banner }]}
                  key={index}
                  smallVideo={true}
                />
              );
            }
            if (!banner.src && banner.srcList.length !== 0) {
              const bannersCopy = banner.srcList.map((item) => {
                if (item.type === "Image") {
                  return { ...banner, src: item.src, type: "Image" };
                } else {
                  return {
                    ...banner,
                    src: item.src,
                    videoCover: item.videoCover,
                    type: "Video",
                  };
                }
              });
              return <BannerSlider banners={bannersCopy} key={index} />;
            }

            if (banner.rowCount > 1) {
              return (
                <div
                  className={`${
                    banner.rowCount === 2
                      ? "col-6"
                      : banner.rowCount === 3
                      ? "col-4"
                      : "col-3"
                  }  mx-0 px-1`}
                  key={index}
                >
                  <SmallBanner
                    src={banner.src}
                    href={banner.link}
                    title={banner.title}
                    showText={banner.titleVisible}
                    glow={banner.highlight}
                    linkNewTab={banner.linkNewTab ? banner.linkNewTab : false}
                  />
                </div>
              );
            } else {
              return (
                <div className="col-12 mx-0 px-0 px-md-2" key={index}>
                  <Banner
                    src={banner.src}
                    href={banner.link}
                    linkNewTab={banner.linkNewTab ? banner.linkNewTab : false}
                    title={banner.title}
                    showText={banner.titleVisible}
                    date={banner.timer}
                    dateLabel={banner.timerLabel}
                    glow={banner.highlight}
                  />
                </div>
              );
            }
          })}
      {!loading && includeArchive && <ArchiveBanner />}
    </div>
  );
}

export default BottomBanners;
